<template lang="html">
  <div id="app">
    <div class="flex justify-center">
      <div class="w-full xs:max-w-428 sm:max-wd-none lg:max-w-548">
        <div v-if="verfication_sent" class="mt-8">
          <div class="font-bold text-2xl mb-4">Verification link has been sent to your email id</div>
          <div class="text-sm mb-8">Please click on the link that has just been sent to you via email to continue the registration process.</div>
          <a class="fs-black-btn w-20 py-1" href="/">Done</a>
        </div>

        <form-wizard @on-complete="onComplete" title="" @on-change="onChange" subtitle="" color="#297cfd" v-else>
          <tab-content :before-change="() => validateStep('step1')" v-if="!editProfile">
            <step1 ref="step1" @on-validate="mergePartialModels" :resource="resource" :currentUser="currentUser" :stadiumInfo="stadiumInfo" :stadium_code="stadium_code"></step1>
          </tab-content>

          <tab-content :before-change="() => validateStep('step2')">
            <step2 ref="step2" @on-validate="mergePartialModels" :currentUser="currentUser" :suggestedUsernames="suggestedUsernames" :stadium_code="stadium_code"></step2>
          </tab-content>

          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <wizard-button  v-if="props.activeTabIndex > 0" @click.native="props.prevTab()" class="fs-back-btn"><i class="fas fa-arrow-left text-slategrey cursor-pointer" /></wizard-button>
            </div>
            <div class="wizard-footer-right rs-mb-16">

              <wizard-button v-if="props.isLastStep && (stadium_code == '' || (stadium_code!='' && stadiumInfo))" @click.native="onComplete" class="rs-purple-btn wizard-footer-right finish-button">Create account  -></wizard-button>

              <wizard-button v-else-if="props.isLastStep && (stadium_code!='' && (stadiumInfo=='' || stadiumInfo==null))" @click.prevent="" class="rs-purple-btn wizard-footer-right finish-button">Create account  -></wizard-button>

              <wizard-button v-else-if="stadium_code == '' || (stadium_code!='')" @click.native="props.nextTab()" class="rs-purple-btn wizard-footer-right">Next</wizard-button>
              <!-- <wizard-button v-else @click.native="props.nextTab()" class="fs-blue-btn wizard-footer-right">Next</wizard-button> -->

              <wizard-button v-else @click.prevent="" class="rs-purple-btn wizard-footer-right">Next</wizard-button>
            </div>
          </template>

        </form-wizard>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import { required, minLength } from 'vuelidate/lib/validators';
  import step1 from './steps/step1';
  import step2 from './steps/step2';

  export default {
    components: {
      step1,
      step2,
    },
    props: {
      editProfile: Boolean,
      currentUser: Object,
      resource: Object,
      invitation_token: String,
      stadium_code: String,
      stadiumInfo: Object,
    },
    data() {
      return {
        user: {},
        isSkipButton: true,
        suggestedUsernames: [],
        verfication_sent: false,
      }
    },
    validations: {
    },
    created(){
    },
    mounted() {
    },
    methods: {
      validateStep(name) {
        var refToValidate = this.$refs[name];
        return refToValidate.validate();
      },
      mergePartialModels(model, isValid){
        if(isValid){
         this.user = Object.assign({},this.user, model)
        }
      },
      onComplete(){
        if(this.currentUser){
          this.updateUserProfile()
        }else{
          this.createUser()
        }
      },
      createUser(){
        if (!this.validateStep('step2'))
          return

        // delete this.user.avatar_base64;

        // if(this.user.avatar == null){ delete this.user.avatar }
        // if(this.user.cover_image == null){ delete this.user.cover_image }

        var form_data = new FormData();

        for ( var key in this.user ) {
          {
            form_data.append("user["+key+"]", this.user[key]);
          }
        };

        var _this = this;
        if(this.resource){
          // create user by invitation link
          var url = '/users/invitation';
          var method = 'put';
          form_data.append("user[invitation_token]", this.invitation_token);
        }else{
          // create user by signup form
          var url = '/users.json';
          var method = 'post';
        }
        axios({
          method: method,
          headers: {
            "Accept": 'application/vnd.reset+json;version=1',
            "X-CSRF-Token": document.getElementsByName('csrf-token')[0].getAttribute('content')
          },
          url: url,
          data: form_data,
        }).then((response) => {
          // console.log('response', response);
          if(response.status === 201 || response.status === 406){
            // this.verfication_sent = true
             this.success("You've successfully registered. Welcome to Re:Set!", '/users/login')
          }else if(response.status === 204 && this.resource){
            // this.success('Successfully registered.', '/?tour=true')
            this.success("You've successfully registered. Welcome to Re:Set!", '/')
          }
        })
        .catch((error) => {
          // console.log('error response', error.response);
          if(error.response.status === 422){
            var errors = error.response.data.errors;
            var errors_arr = []
            for (var key in errors) {
              if (errors.hasOwnProperty(key)) {
                errors_arr.push(`<li>${key} ${errors[key]}</li>`);
              }
            }
            this.error(errors_arr);
          }
        });
      },
      updateUserProfile(){
        if (!this.validateStep('step7'))
          return

        var payload = {
          avatar: this.user.avatar_base64,
          birth_date: this.user.birth_date,
        }

        this.$emit('update-profile', payload)
      },
      success(message, location){
        this.$swal({
          text: message,
          type: 'success',
        }).then((result) => {
          if (result.value) {
            window.location = location
          }
        });
      },
      error(message){
        this.$swal({
          html: `<ul>${message}</ul>`,
          type: 'error',
        })
      },
      onChange(prev, next){
        
      },
    }
  };
</script>

<style scoped>
.-mb-18{
  margin-bottom: -4.5rem;
}

.fs-blue-btn {
  @apply bg-gradient-r-blue text-center text-white py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-sm border-0;
  min-width:auto;
}

.fs-black-btn {
  @apply bg-black text-center text-white py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-sm border-0;
  min-width:auto;
}

.fs-back-btn {
  @apply bg-lightgrey rounded-full w-8 h-8 flex text-white font-semibold justify-center items-center cursor-pointer;
  min-width:auto;
}

.rs-purple-btn {
  @apply bg-rspurple text-center text-white py-2 px-6 rounded-full cursor-pointer outline-none text-sm;
  font-family: 'SofiaPro-Bold' !important;
  font-weight: 600;
}

.fs-darkgrey-btn {
  @apply bg-darkgrey text-center text-white py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-sm;
  min-width:auto;
}
</style>

<style>
.wizard-card-footer1{
  display: none !important;
}

.wizard-header, .wizard-nav, .wizard-progress-with-circle{
  display: none !important;
}
.vue-form-wizard{
  width: 100%;
  padding-top: 0rem;
}
.vue-form-wizard .wizard-tab-content {
  width: 100%;
  float: left;
  padding: 2rem 0;
}
.vue-form-wizard .wizard-card-footer {
  width: 100%;
  float: left;
  padding: 0rem 1rem;
}
.vue-form-wizard .wizard-card-footer .wizard-footer-left {
  float: left;
}
.vue-form-wizard .wizard-card-footer .wizard-footer-right {
  float: right;
}
/*.invalid-feedback {
  display: block;
  width: 100%;
  font-size: 80%;
  color: #dc3545;
}*/

@media only screen and (max-width: 600px) {
  .vue-form-wizard .wizard-card-footer {
    padding: 0;
  }

  /* .vue-form-wizard .wizard-tab-content {
    padding-bottom: 0;
  } */
}
.rs-mb-16 {
  margin-bottom: 0px;
}
@media only screen and (max-height: 900px) {
  .rs-mb-16 {
    margin-bottom: 4rem;
  }
}
@responsive {
  .max-w-548 {
    max-width: 548px;
  }
  .max-w-428 {
    max-width: 428px;
  }
  .max-wd-none {
    max-width: none;
  }
}
</style>

<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  font-size: 80%;
  color: #dc3545;
}
</style>
